import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { succsesDataChangeAlert } from "../../alerts/alerts";
import { useGetPageQuery, useSendFormMutation } from "../../redux/services/crmAPI";

const CurrentStore = () => {
    const navigate = useNavigate();

    const permissions = useSelector((state) => state.status.permissions);

    const { id } = useParams();

    const { data: store, refetch: refetchStore } = useGetPageQuery("stores/" + id);
    const [sendForm, { isLoading, isError }] = useSendFormMutation();

    const [active, setActive] = useState("");
    const [useCashier, setUseCashier] = useState(0);
    const [isShowInServices, setIsShowInServices] = useState(0);
    const [title, setTitle] = useState("");
    const [titleSticker, setTitleSticker] = useState("");
    const [titleWarranty, setTitleWarranty] = useState("");
    const [telegramId, setTelegramId] = useState("");
    const [telegramSaleId, setTelegramSaleId] = useState("");
    const [telegramAccessoriesId, setTelegramAccessoriesId] = useState("");
    const [address, setAdress] = useState("");
    const [phones, setPhones] = useState("");
    const [worktime, setWorktime] = useState("");
    const [olx, setOlx] = useState("");
    const [cashierName, setCashierName] = useState("");
    const [cashierLogin, setCashierLogin] = useState("");
    const [cashierPassword, setCashierPassword] = useState("");
    const [cashierLicense, setCashierLicense] = useState("");
    const [cashierChairname, setCashierChairname] = useState("");
    const [cashierCommission, setCashierCommission] = useState("");
    const [cashierCompany, setCashierCompany] = useState("");
    const [cashierTin, setCashierTin] = useState("");
    const [dropboxPhone, setDropboxPhone] = useState("");
    const [dropboxLaptop, setDropboxLaptop] = useState("");
    const [dropboxTablet, setDropboxTablet] = useState("");

    useEffect(() => {
        if (store) {
            setActive(store.active);
            setUseCashier(store.use_cashier);
            setIsShowInServices(store.is_show_in_services);
            setTitle(store.title);
            setTitleSticker(store.title_sticker);
            setTitleWarranty(store.title_warranty);
            setTelegramId(store.telegram_id);
            setTelegramSaleId(store.telegram_sale_id);
            setTelegramAccessoriesId(store.telegram_accessories_id);
            setAdress(store.address);
            setPhones(store.phones);
            setWorktime(store.worktime);
            setOlx(store.olx);
            setCashierName(store.cashier_name);
            setCashierLogin(store.cashier_login);
            setCashierPassword(store.cashier_password);
            setCashierLicense(store.cashier_license);
            setCashierChairname(store.cashier_chairname);
            setCashierCommission(store.cashier_commission);
            setCashierCompany(store.cashier_company);
            setCashierTin(store.cashier_tin);
            setDropboxPhone(store.dropbox_phone);
            setDropboxLaptop(store.dropbox_laptop);
            setDropboxTablet(store.dropbox_tablet);
        }
    }, [store]);

    const sendFormHandler = async () => {
        const formData = {
            title: title,
            title_sticker: titleSticker,
            title_warranty: titleWarranty,
            telegram_id: telegramId,
            telegram_sale_id: telegramSaleId,
            telegram_accessories_id: telegramAccessoriesId,
            address: address,
            phones: phones,
            worktime: worktime,
            olx: olx,
            cashier_name: cashierName,
            cashier_login: cashierLogin,
            cashier_password: cashierPassword,
            cashier_license: cashierLicense,
            cashier_chairname: cashierChairname,
            cashier_commission: cashierCommission,
            cashier_company: cashierCompany,
            cashier_tin: cashierTin,
            dropbox_phone: dropboxPhone,
            dropbox_laptop: dropboxLaptop,
            dropbox_tablet: dropboxTablet,
            use_cashier: useCashier,
            active: active,
            is_show_in_services: isShowInServices,
        };

        await sendForm({ body: formData, url: "stores/" + id, method: "PUT" }).unwrap();
        await refetchStore();

        if (!isError) {
            succsesDataChangeAlert();
            navigate("/stores/1");
        }
    };

    return (
        <>
            {store && (
                <div className="content">
                    <div className="col-12">
                        <div id="page-header">
                            <h1>{store.title}</h1>
                        </div>
                        <div className="form user_form">
                            <input
                                type="hidden"
                                name="id"
                            />
                            <div className="row">
                                <div className="col-12 col-sm-6 col-lg-6">
                                    <div className="card card-default">
                                        <div className="card-header">
                                            Інформація про магазин
                                            <div className="d-flex flex-wrap gap-3 mt-1">
                                                <div className="form-check">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input"
                                                        checked={active}
                                                        onChange={(e) => setActive(+e.target.checked)}
                                                    />
                                                    <label className="form-label">Активний</label>
                                                </div>
                                                <div className="form-check">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input"
                                                        checked={useCashier}
                                                        onChange={(e) => setUseCashier(+e.target.checked)}
                                                    />
                                                    <label className="form-label">Використовувати касу</label>
                                                </div>
                                                <div className="form-check">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input"
                                                        checked={isShowInServices}
                                                        onChange={(e) => setIsShowInServices(+e.target.checked)}
                                                    />
                                                    <label className="form-label">Показувати в сервісах</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card-body">
                                            <div className="mb-3">
                                                <label className="form-label">Назва</label>
                                                <input
                                                    className="form-control"
                                                    maxLength="255"
                                                    type="text"
                                                    value={title}
                                                    onChange={(e) => setTitle(e.target.value)}
                                                />
                                            </div>
                                            <div className="mb-3">
                                                <label className="form-label">Назва на наклейці</label>
                                                <input
                                                    className="form-control"
                                                    name="print_name"
                                                    maxLength="255"
                                                    type="text"
                                                    value={titleSticker}
                                                    onChange={(e) => setTitleSticker(e.target.value)}
                                                />
                                            </div>
                                            <div className="mb-3">
                                                <label className="form-label">Назва на гарантії</label>
                                                <input
                                                    className="form-control"
                                                    name="warranty_name"
                                                    maxLength="255"
                                                    type="text"
                                                    value={titleWarranty}
                                                    onChange={(e) => setTitleWarranty(e.target.value)}
                                                />
                                            </div>
                                            <div className="mb-3">
                                                <label className="form-label">Telegram ID</label>
                                                <input
                                                    className="form-control"
                                                    name="chat_id"
                                                    maxLength="255"
                                                    type="text"
                                                    value={telegramId}
                                                    onChange={(e) => setTelegramId(e.target.value)}
                                                />
                                            </div>
                                            <div className="mb-3">
                                                <label className="form-label">Telegram Sale ID</label>
                                                <input
                                                    className="form-control"
                                                    name="chat_sale_id"
                                                    maxLength="255"
                                                    type="text"
                                                    value={telegramSaleId}
                                                    onChange={(e) => setTelegramSaleId(e.target.value)}
                                                />
                                            </div>
                                            <div className="mb-3">
                                                <label className="form-label">Telegram Accessories ID</label>
                                                <input
                                                    className="form-control"
                                                    name="chat_accessories_id"
                                                    maxLength="255"
                                                    type="text"
                                                    value={telegramAccessoriesId}
                                                    onChange={(e) => setTelegramAccessoriesId(e.target.value)}
                                                />
                                            </div>
                                            <div className="mb-3">
                                                <label className="form-label">Адреса</label>
                                                <input
                                                    className="form-control"
                                                    name="address"
                                                    maxLength="255"
                                                    type="text"
                                                    value={address}
                                                    onChange={(e) => setAdress(e.target.value)}
                                                />
                                            </div>
                                            <div className="mb-3">
                                                <label className="form-label">Телефони</label>
                                                <input
                                                    className="form-control"
                                                    name="phone"
                                                    maxLength="255"
                                                    type="text"
                                                    value={phones}
                                                    onChange={(e) => setPhones(e.target.value)}
                                                />
                                            </div>
                                            <div className="mb-3">
                                                <label className="form-label">Режим роботи</label>
                                                <textarea
                                                    className="form-control"
                                                    name="shedule"
                                                    maxLength="255"
                                                    type="text"
                                                    value={worktime}
                                                    onChange={(e) => setWorktime(e.target.value)}
                                                ></textarea>
                                            </div>

                                            <div className="mb-3">
                                                <label className="form-label">Аккаунти ОЛХ</label>
                                                <textarea
                                                    className="form-control"
                                                    name="olx_accounts"
                                                    type="text"
                                                    value={olx}
                                                    onChange={(e) => setOlx(e.target.value)}
                                                ></textarea>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-sm-6 col-lg-6">
                                    <div className="card card-default no-mobile">
                                        <div className="card-header">Статистика</div>
                                        <div className="card-body">
                                            <table className="table table-striped">
                                                <tbody>
                                                    <tr>
                                                        <th>Категорія</th>
                                                        <th>Товари</th>
                                                        <th>Закупка</th>
                                                        <th>Закупка USD</th>
                                                        <th>Продаж </th>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div className="card card-default">
                                        <div className="card-header">
                                            пРРО Каса - CheckBox.UA
                                            <div className="float-end">
                                                <a
                                                    href="print?inventory="
                                                    target="_blank"
                                                >
                                                    Інвентаризаційний лист
                                                </a>
                                            </div>
                                            <div className="clearfix"></div>
                                        </div>
                                        <div className="card-body">
                                            <div className="mb-3">
                                                <label className="form-label">
                                                    ФІО Касира (для гарантійного талона)
                                                </label>
                                                <input
                                                    className="form-control"
                                                    name="cashier_name"
                                                    maxLength="255"
                                                    type="text"
                                                    value={cashierName}
                                                    onChange={(e) => setCashierName(e.target.value)}
                                                />
                                            </div>
                                            <div className="mb-3">
                                                <label className="form-label">Логін касира</label>
                                                <input
                                                    className="form-control"
                                                    name="checkbox_login"
                                                    maxLength="255"
                                                    type="text"
                                                    value={cashierLogin}
                                                    onChange={(e) => setCashierLogin(e.target.value)}
                                                />
                                            </div>
                                            <div className="mb-3">
                                                <label className="form-label">Пароль касира</label>
                                                <input
                                                    className="form-control"
                                                    name="checkbox_password"
                                                    maxLength="255"
                                                    type="text"
                                                    value={cashierPassword}
                                                    onChange={(e) => setCashierPassword(e.target.value)}
                                                />
                                            </div>
                                            <div className="mb-3">
                                                <label className="form-label">Ключ ліцензії каси</label>
                                                <input
                                                    className="form-control"
                                                    name="checkbox_license_key"
                                                    maxLength="255"
                                                    type="text"
                                                    value={cashierLicense}
                                                    onChange={(e) => setCashierLicense(e.target.value)}
                                                />
                                            </div>

                                            <div className="mb-3">
                                                <label className="form-label">
                                                    ФІО Голови комісії (інвентаризаційний лист)
                                                </label>
                                                <input
                                                    className="form-control"
                                                    name="inventory_director"
                                                    maxLength="255"
                                                    type="text"
                                                    value={cashierChairname}
                                                    onChange={(e) => setCashierChairname(e.target.value)}
                                                />
                                            </div>
                                            <div className="mb-3">
                                                <label className="form-label">
                                                    ФІО членів комісії (інвентаризаційний лист)
                                                </label>
                                                <input
                                                    className="form-control"
                                                    name="inventory_comission"
                                                    maxLength="255"
                                                    type="text"
                                                    value={cashierCommission}
                                                    onChange={(e) => setCashierCommission(e.target.value)}
                                                />
                                            </div>
                                            <div className="mb-3">
                                                <label className="form-label">Назва компанії</label>
                                                <input
                                                    className="form-control"
                                                    name="inventory_company"
                                                    maxLength="255"
                                                    type="text"
                                                    value={cashierCompany}
                                                    onChange={(e) => setCashierCompany(e.target.value)}
                                                />
                                            </div>
                                            <div className="mb-3">
                                                <label className="form-label">ІПН / ЄДРПОУ</label>
                                                <input
                                                    className="form-control"
                                                    name="inventory_inn"
                                                    maxLength="255"
                                                    type="text"
                                                    value={cashierTin}
                                                    onChange={(e) => setCashierTin(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card card-default">
                                        <div className="card-header">Dropbox</div>
                                        <div className="card-body">
                                            <div className="mb-3">
                                                <label className="form-label">Dropbox телефони</label>
                                                <input
                                                    className="form-control"
                                                    name="db_folder_phones"
                                                    maxLength="255"
                                                    type="text"
                                                    value={dropboxPhone}
                                                    onChange={(e) => setDropboxPhone(e.target.value)}
                                                />
                                            </div>
                                            <div className="mb-3">
                                                <label className="form-label">Dropbox ноутбуки</label>
                                                <input
                                                    className="form-control"
                                                    name="db_folder_notebooks"
                                                    maxLength="255"
                                                    type="text"
                                                    value={dropboxLaptop}
                                                    onChange={(e) => setDropboxLaptop(e.target.value)}
                                                />
                                            </div>
                                            <div className="mb-3">
                                                <label className="form-label">Dropbox планшети</label>
                                                <input
                                                    className="form-control"
                                                    name="db_folder_tablets"
                                                    maxLength="255"
                                                    type="text"
                                                    value={dropboxTablet}
                                                    onChange={(e) => setDropboxTablet(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 clearfix">
                                    {permissions.includes("store_edit") || permissions.includes("all") ? (
                                        <div className="saves_block">
                                            <button
                                                name="store_info"
                                                className="btn btn-primary"
                                                onClick={sendFormHandler}
                                            >
                                                {isLoading ? "Завантаження" : "Зберегти"}
                                            </button>
                                        </div>
                                    ) : null}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default CurrentStore;
